import React, { useState } from 'react';
import { Form, Button, ListGroup } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './Task.css';  // new CSS file for styling

function Tasks({ user, setUser }) {
  const [task, setTask] = useState('');
  const [deadline, setDeadline] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);

  const saveUserData = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('currentUser', JSON.stringify(updatedUser));
    const users = JSON.parse(localStorage.getItem('users')).map(u =>
      u.email === user.email ? updatedUser : u
    );
    localStorage.setItem('users', JSON.stringify(users));
  };

  const addTask = () => {
    if (!task.trim()) return;
    const newTask = { id: Date.now(), text: task.trim(), deadline };
    saveUserData({ ...user, tasks: [...user.tasks, newTask] });
    setTask('');
  };

  const deleteTask = (id) => {
    saveUserData({ ...user, tasks: user.tasks.filter(t => t.id !== id) });
  };

  const editTask = (id, newText) => {
    if (newText === null || newText.trim() === '') return;
    saveUserData({
      ...user,
      tasks: user.tasks.map(t => t.id === id ? { ...t, text: newText.trim() } : t)
    });
  };

  return (
    <div className="tasks-container">
      <h3 className="tasks-title">📝 Tasks</h3>
      <Form.Group className="mb-3">
        <Form.Control
          type="text"
          value={task}
          onChange={(e) => setTask(e.target.value)}
          placeholder="Add a task"
          className="task-input"
        />
      </Form.Group>
      <div className="button-group">
        <Button variant="outline-light" onClick={() => setShowCalendar(!showCalendar)}>
          📅 Pick Deadline
        </Button>
        <Button variant="primary" onClick={addTask} className="ms-2">
          ➕ Add Task
        </Button>
      </div>
      {showCalendar && (
        <div className="calendar-wrapper">
          <Calendar onChange={setDeadline} value={deadline} />
        </div>
      )}
      <ListGroup className="mt-3 task-list">
        {user.tasks.map((task) => (
          <ListGroup.Item key={task.id} className="task-item">
            <span className="task-text">{task.text} - {new Date(task.deadline).toDateString()}</span>
            <div className="task-actions">
              <Button
                variant="link"
                className="edit-btn"
                onClick={() => {
                  const newText = prompt('Edit task:', task.text);
                  editTask(task.id, newText);
                }}
              >
                ✏️ Edit
              </Button>
              <Button variant="link" className="delete-btn" onClick={() => deleteTask(task.id)}>
                🗑️ Delete
              </Button>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
}

export default Tasks;
